export default __webpack_public_path__ + "static/media/icon-success.489355c1.svg";